import DelBox from "../comps/DelBox";
import NewOrder1 from "../models/NewOrder1";
import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";

function StorePurchase() {
    const today = new Date().toISOString().split('T')[0];
    
    const [formData, setFormData] = useState({
        l1: [],
        store_purchase_type: 'normal',
        suppliers: [],
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        from: '',
        to: '',
        isAlert: false,
    });
    const [isAdmin, setIsAdmin] = useState('');
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);


    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // View Modal State
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
        
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', 'none');
            fd.append('search_key', formData.search_key + "");
            fd.append('store_purchase_type', formData.store_purchase_type);
            fd.append('from', formData.from || '');
            fd.append('to', formData.to || '');
            
            console.log("Sending Request:", {
                page_no: 'none',
                search_key: formData.search_key,
                store_purchase_type: formData.store_purchase_type,
                from: formData.from,
                to: formData.to
            });
            
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getStorePurchaseListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                
                console.log("Purchase List Response:", response.data);
                
                if (response.data.status) {
                    var records = response.data.records;
                    setFormData(prev => ({
                        ...prev,
                        l1: records || []
                    }));
                } else {
                    setFormData(prev => ({
                        ...prev,
                        l1: []
                    }));
                }
            } catch (error) {
                console.error("Error fetching purchases:", error);
                toast.error("Failed to fetch purchase list");
            }
        }
    };

    const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "supplier1");
            fd.append('search_key', '');
            fd.append('page_no', 'none');
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("supplier : " + JSON.stringify(response));
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            suppliers: records
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching suppliers:", error);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClear = () => {
        const todayDate = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            search_key: "",
            from: todayDate,
            to: todayDate,
        }));
        setTimeout(() => initData(), 100);
    };

    const delItem = async (item) => {
        if (!window.confirm("Are you sure you want to delete this purchase?")) return;

        const fd = new FormData();
        fd.append('store_purchase_id', item.store_purchase_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                toast.success("Purchase deleted successfully");
                initData();
            } else {
                toast.error("Failed to delete purchase");
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error("Failed to delete purchase");
        }
    };

    const handleEdit = (item) => {
        // ✅ Ensure items have batch_no from database field
        const itemsWithBatch = (item.items || []).map(itm => ({
            ...itm,
            store_batch_no: itm.store_purchase_item_batch_no || itm.store_batch_no || '',
            store_department: itm.store_purchase_item_department || itm.store_department || '',
            store_hsn: itm.store_purchase_item_hsn || itm.store_hsn || '',
        }));

        const editData = {
            ...item,
            items: itemsWithBatch
        };

        sessionStorage.setItem("opd_dt", JSON.stringify(editData));
        window.location.href = "/add_purchase";
    };

    const handleView = (item) => {
        setSelectedPurchase(item);
        setShowViewModal(true);
    };

    useEffect(() => {
        if (ldata) {
            initData();
        }
    }, [formData.from, formData.to]);

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const getVendorName = (id) => {
        const vendor = formData.suppliers.find((v) => v.user_id == id);
        if (!vendor) return "N/A";
        return vendor.fname + (vendor.lname ? " " + vendor.lname : "");
    };

    // DataTable Columns
    const columns = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Invoice No.',  // ✅ CHANGED FROM Purchase No.
            selector: row => row.store_invoice_number,
            sortable: true,
            cell: row => <span className="badge bg-primary-subtle text-primary">{row.store_invoice_number || 'N/A'}</span>
        },
        {
            name: 'Purchase Date',
            selector: row => row.store_purchase_date,
            sortable: true,
        },
        {
            name: 'Supplier',
            selector: row => getVendorName(row.store_purchase_vendor),
            sortable: true,
        },
        {
            name: 'Total Amount',
            selector: row => row.store_purchase_total,
            sortable: true,
            cell: row => <strong>₹{parseFloat(row.store_purchase_total || 0).toFixed(2)}</strong>
        },
        {
            name: 'Discount',
            selector: row => row.store_purchase_dis,
            sortable: true,
            cell: row => `₹${parseFloat(row.store_purchase_dis || 0).toFixed(2)}`
        },
        {
            name: 'GST',
            selector: row => row.store_purchase_gst,
            sortable: true,
            cell: row => `₹${parseFloat(row.store_purchase_gst || 0).toFixed(2)}`
        },
        {
            name: 'Grand Total',
            selector: row => row.store_purchase_gtotal,
            sortable: true,
            cell: row => <strong className="text-success">₹{parseFloat(row.store_purchase_gtotal || 0).toFixed(2)}</strong>
        },
        {
            name: 'Action',
            cell: (row) => (
                <div className="d-flex gap-1">
                    <button
                        type="button"
                        className="btn btn-sm btn-info"
                        onClick={() => handleView(row)}
                        title="View Details"
                    >
                        <i className="ri-eye-line"></i>
                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-warning"
                        disabled={!isAdmin}
                        style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={() => handleEdit(row)}
                        title="Edit"
                    >
                        <i className="ri-pencil-line"></i>
                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        disabled={!isAdmin}
                        style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={() => delItem(row)}
                        title="Delete"
                    >
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '150px',
        },
    ];

    // Filter data
    const filteredData = formData.l1.filter(item => {
        if (!formData.search_key) return true;
        const searchTerm = formData.search_key.toLowerCase();
        return (
            item.store_purchase_no?.toLowerCase().includes(searchTerm) ||
            getVendorName(item.store_purchase_vendor).toLowerCase().includes(searchTerm) ||
            item.store_invoice_number?.toLowerCase().includes(searchTerm)
        );
    });


    const currentPageRows = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    
    const pageSummary = currentPageRows.reduce(
        (acc, item) => {
            acc.total      += parseFloat(item.store_purchase_total || 0);
            acc.discount   += parseFloat(item.store_purchase_dis || 0);
            acc.gst        += parseFloat(item.store_purchase_gst || 0);
            acc.grandTotal += parseFloat(item.store_purchase_gtotal || 0);
            return acc;
        },
        { total: 0, discount: 0, gst: 0, grandTotal: 0 }
    );


    // Custom styles
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#f3f6f9',
                fontWeight: 'bold',
                fontSize: '14px',
                borderBottom: '2px solid #405189',
            },
        },
        rows: {
            style: {
                minHeight: '56px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                },
            },
        },
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Store Purchase</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-1 flex-wrap">
                                            <button type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    sessionStorage.removeItem("opd_dt");
                                                    window.location.href = "/add_purchase";
                                                }}
                                                className="btn btn-success add-btn">
                                                <i className="ri-add-line align-bottom me-1"></i> New Entry
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-2">
                                            <label className="form-label">From Date</label>
                                            <input 
                                                className="form-control" 
                                                type="date" 
                                                name="from" 
                                                onChange={handleChange} 
                                                value={formData.from} 
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">To Date</label>
                                            <input 
                                                className="form-control" 
                                                type="date" 
                                                name="to" 
                                                onChange={handleChange} 
                                                value={formData.to} 
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Actions</label>
                                            <div className="d-flex gap-2">
                                                <button 
                                                    type="button" 
                                                    onClick={handleClear}
                                                    className="btn btn-primary"
                                                    title="Show today's purchases"
                                                >
                                                   Clear
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3">
                                            <label className="form-label">Search</label>
                                            <div className="search-box">
                                            <input 
    className="form-control search" 
    placeholder="Search by Invoice No, Supplier..." 
    type="text"
    name="search_key" 
    onChange={(e) => { handleChange(e); setCurrentPage(1); }} 
    value={formData.search_key} 
/>
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="card-body pt-0">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted">
                                        {formData.from && formData.to ? (
                                            <>Showing {filteredData.length} purchase(s) from <strong>{formData.from}</strong> to <strong>{formData.to}</strong></>
                                        ) : formData.from ? (
                                            <>Showing {filteredData.length} purchase(s) from <strong>{formData.from}</strong> onwards</>
                                        ) : formData.to ? (
                                            <>Showing {filteredData.length} purchase(s) up to <strong>{formData.to}</strong></>
                                        ) : (
                                            <>Showing all {filteredData.length} purchase(s)</>
                                        )}
                                    </small>
                                </div>
                                
                                <DataTable
    columns={columns}
    data={filteredData}
    pagination
    paginationPerPage={rowsPerPage}
    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
    onChangePage={(page) => setCurrentPage(page)}
    onChangeRowsPerPage={(newPerPage, page) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(page);
    }}
    highlightOnHover
    striped
    responsive
    customStyles={customStyles}
    noDataComponent={
        <div className="text-center py-5">
            <i className="ri-shopping-cart-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
            <p className="mt-3 text-muted">No purchases found</p>
            {(formData.from || formData.to) && (
                <small className="text-muted">
                    Try selecting a different date range or click "Clear"
                </small>
            )}
        </div>
    }
/>


{/* ✅ Page-wise Summary Footer */}
{filteredData.length > 0 && (
    <div className="mt-3 pt-3 border-top">
        <div className="row text-center g-2">
            <div className="col-md-3">
                <div className="alert alert-primary mb-0 py-2">
                    <small className="d-block text-muted">Total Amount (Page {currentPage})</small>
                    <strong>₹{pageSummary.total.toFixed(2)}</strong>
                </div>
            </div>
            <div className="col-md-3">
                <div className="alert alert-warning mb-0 py-2">
                    <small className="d-block text-muted">Total Discount (Page {currentPage})</small>
                    <strong>₹{pageSummary.discount.toFixed(2)}</strong>
                </div>
            </div>
            <div className="col-md-3">
                <div className="alert alert-info mb-0 py-2">
                    <small className="d-block text-muted">Total GST (Page {currentPage})</small>
                    <strong>₹{pageSummary.gst.toFixed(2)}</strong>
                </div>
            </div>
            <div className="col-md-3">
                <div className="alert alert-success mb-0 py-2">
                    <small className="d-block text-muted">Grand Total (Page {currentPage})</small>
                    <strong>₹{pageSummary.grandTotal.toFixed(2)}</strong>
                </div>
            </div>
        </div>
    </div>
)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* View Purchase Items Modal */}
            {showViewModal && selectedPurchase && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#405189', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-file-list-3-line me-2"></i>
                                        Purchase Details - Invoice #{selectedPurchase.store_invoice_number || 'N/A'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => {
                                            setShowViewModal(false);
                                            setSelectedPurchase(null);
                                        }}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    {/* Purchase Info */}
                                    <div className="alert alert-light border mb-3">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Invoice No:</strong> {selectedPurchase.store_invoice_number || 'N/A'}</p>
                                                <p className="mb-1"><strong>Purchase Date:</strong> {selectedPurchase.store_purchase_date}</p>
                                                <p className="mb-1"><strong>Supplier:</strong> {getVendorName(selectedPurchase.store_purchase_vendor)}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Invoice Date:</strong> {selectedPurchase.store_invoice_date || 'N/A'}</p>
                                                <p className="mb-1"><strong>Payment Mode:</strong> {selectedPurchase.store_purchase_mode || 'N/A'}</p>
                                                <p className="mb-1"><strong>Purchase No:</strong> #{selectedPurchase.store_purchase_no}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items Table */}
                                    <h6 className="mb-3">Purchase Items</h6>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead style={{ backgroundColor: '#405189', color: '#fff' }}>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Item Name</th>
                                                    <th>Batch No</th>
                                                    <th>Unit</th>
                                                    <th className="text-end">Rate</th>
                                                    <th className="text-center">Qty</th>
                                                    <th className="text-center">Test Do</th>
                                                    <th className="text-end">Discount %</th>
                                                    <th className="text-end">Discount Amt</th>
                                                    <th className="text-end">GST %</th>
                                                    <th className="text-end">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedPurchase.items && selectedPurchase.items.length > 0 ? (
                                                    selectedPurchase.items.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td>{idx + 1}</td>
                                                            <td>{item.store_purchase_item_name}</td>
                                                            <td>{item.store_purchase_item_batch_no || 'N/A'}</td>
                                                            <td>{item.store_purchase_item_unit}</td>
                                                            <td className="text-end">₹{parseFloat(item.store_purchase_item_rate || 0).toFixed(2)}</td>
                                                            <td className="text-center">{item.store_purchase_item_qty}</td>
                                                            <td className="text-center">{item.store_purchase_test_qty}</td>
                                                            <td className="text-end">{item.store_purchase_item_dis}%</td>
                                                            <td className="text-end">₹{parseFloat(item.store_purchase_item_dis_amt || 0).toFixed(2)}</td>
                                                            <td className="text-end">{item.store_purchase_item_gst}%</td>
                                                            <td className="text-end"><strong>₹{parseFloat(item.store_purchase_item_total || 0).toFixed(2)}</strong></td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center text-muted">No items found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            {selectedPurchase.items && selectedPurchase.items.length > 0 && (
                                                <tfoot className="table-light">
                                                    <tr>
                                                        <th colSpan="9" className="text-end">Total Amount:</th>
                                                        <th className="text-end">₹{parseFloat(selectedPurchase.store_purchase_total || 0).toFixed(2)}</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="9" className="text-end">Discount:</th>
                                                        <th className="text-end text-danger">-₹{parseFloat(selectedPurchase.store_purchase_dis || 0).toFixed(2)}</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="9" className="text-end">GST:</th>
                                                        <th className="text-end">₹{parseFloat(selectedPurchase.store_purchase_gst || 0).toFixed(2)}</th>
                                                    </tr>
                                                    <tr style={{ backgroundColor: '#e7f1ff' }}>
                                                        <th colSpan="9" className="text-end">Grand Total:</th>
                                                        <th className="text-end text-success">₹{parseFloat(selectedPurchase.store_purchase_gtotal || 0).toFixed(2)}</th>
                                                    </tr>
                                                </tfoot>
                                            )}
                                        </table>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowViewModal(false);
                                            setSelectedPurchase(null);
                                        }}
                                    >
                                        <i className="ri-close-line me-1"></i> Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
                </>
            )}
        </div>
    );
}

export default StorePurchase;